export const apiCampaigns = `/sp/campaigns/`
export const apiAmazonChanges = "amazon/changes"
